module.exports = __webpack_public_path__ + "assets/fonts/ProximaNova-Light.27615d7e.eot";